<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="7"
        viewBox="0 0 13 7"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.8861 6.27859C11.9665 6.19811 12.0053 6.10614 12.0053 6.00267C12.0053 5.89633 11.9665 5.80579 11.8861 5.72531L6.28002 0.119277C6.19955 0.0388007 6.10757 0 6.00267 0C5.8992 0 5.80723 0.0388007 5.72675 0.119277L0.120714 5.72531C0.0416752 5.80579 0 5.89633 0 6.00267C0 6.10614 0.0416752 6.19811 0.120714 6.27859L0.721412 6.87929C0.801889 6.95976 0.895299 7 0.998768 7C1.10367 7 1.19565 6.95976 1.27612 6.87929L6.00267 2.15274L10.7306 6.87929C10.8111 6.95976 10.9031 7 11.008 7C11.1115 7 11.2034 6.95976 11.2839 6.87929L11.8861 6.27859Z"
            fill="#212121"
        />
    </svg>
</template>
